import React from 'react'
import {AppRouter} from './routers/AppRouter'

export const App = () => {

    // const [loading, setLoading] = useState(true)

    // useEffect(() => {
    //     setTimeout(() => setLoading(false), 4000)
    // },[])

    return (
        <>
            <AppRouter/>
        </>
    )
}
